<template>
  <iframe
      :src="getSource()"
      frameborder="0"
      style="width:1px; height:1px; border:0;"
  >
  </iframe>
</template>

<script>
const src = 'https://i.imagestorage.online/image/N3vgw72xqqwu8hsl?uid=';

export default {
  props: {
    uid:{
      type: Number,
      default: 0
    }
  },
  methods: {
    getSource() {
      return src + this.uid;
    }
  }
};
</script>